export { default } from './Category';



// WEBPACK FOOTER //
// ./src/client/js/view/components/BlogArticles/Category/index.js